import { Link } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';

import AlertDialog from 'components/ui/AlertDialog';
import { closeNotification } from 'store/notificationSlice';

const NotificationDialog = () => {
  const dispatch = useDispatch();
  const isOpen = useSelector((state) => state.notificationDialog.isOpen);
  const title = useSelector((state) => state.notificationDialog.title);
  const text = useSelector((state) => state.notificationDialog.text);
  const isPaymentFailed = useSelector((state) => state.notificationDialog.isPaymentFailed);

  const dialogTitle = isPaymentFailed ? 'Payment Failed' : title;
  const dialogText = isPaymentFailed ? (
    <>
      One or more of your recent payments have failed on your current advertising campaign(s).
      Please update the payment method on file for the corresponding campaign(s) to resolve the
      issue or contact support for assistance at
      {' '}
      <Link href="tel:8778377210">877-837-7210</Link>
      {' '}
      x
      7039 or
      {' '}
      <Link href="mailto:customercare@terraboost.biz">customercare@terraboost.biz</Link>
      .
    </>
  ) : (
    text
  );

  return (
    isOpen && (
      <AlertDialog
        isOpen={isOpen}
        onClose={() => dispatch(closeNotification())}
        title={dialogTitle}
        text={dialogText}
        agreeButtonText="OK"
        onSubmit={() => dispatch(closeNotification())}
      />
    )
  );
};

export default NotificationDialog;
